import { StoreAlertOutlineIcon } from './StoreAlertOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 3D34BFA8-56E0-4FDB-A8CF-7C19AFE14277
 * name store-alert-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-alert-outline.svg
 * tags
 * - Places 
 * - Shopping 
 * - Alert / Error 
 */
export const ShopAlertOutlineIcon = StoreAlertOutlineIcon;
export default ShopAlertOutlineIcon